import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { PerksTypes as constants } from "./reducer"
import * as services from "./services"

const getPerksActions = {
  request: Creators.getPerksRequest,
  success: Creators.getPerksSuccess,
  errors: Creators.getPerksFailure
}

const eventsOptions = {
  [constants.GET_PERKS_REQUEST]: {
    api: services.getPerks,
    actions: getPerksActions
  }
}

export default function* perksSaga() {
  yield takeLatest(constants.GET_PERKS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_PERKS_REQUEST])
  )
}
